import gql from "graphql-tag";

const CREATE_MERCHANT = gql`
  mutation createMerchant($input: CreateMerchantInput!) {
    createMerchant(input: $input) {
      id
      businessName
      firstName
      lastName
      email
    }
  }
`;

const LOGIN_MUTATION = gql`
  mutation loginMerchant($email: String!, $password: String!) {
    loginMerchant(email: $email, password: $password) {
      id
      email
      token
      isVerified
    }
  }
`;

const VERIFY_ACCOUNT = gql`
  mutation verifyAccount($token: String!) {
    verifyAccount(token: $token) {
      id
      email
      token
      isVerified
    }
  }
`;

const START_ONBOARDING = gql`
  mutation startOnboarding($onboardingToken: String!) {
    startOnboarding(token: $onboardingToken) {
      redirectUri
    }
  }
`;
const CREATE_TRANSACTION = gql`
  mutation createTransaction(
    $amount: Float!
    $customerRef: String
    $description: String!
    $currency: String!
    $firstName: String
    $lastName: String
    $phone: String
    $email: String
    $customerId: Int
    $sendSMS: Boolean
  ) {
    createTransaction(
      input: {
        amount: $amount
        customerRef: $customerRef
        description: $description
        currency: $currency
        firstName: $firstName
        lastName: $lastName
        phone: $phone
        email: $email
        customerId: $customerId
        sendSMS: $sendSMS
      }
    ) {
      id
      amount
      customerRef
      description
      ref
      applicationFeeAmount
      customer {
        firstName
      }
      currency
    }
  }
`;

const COMPLETE_ONBOARDING = gql`
  mutation completeOnboarding($input: CompleteOnboardingInput!) {
    completeOnboarding(input: $input) {
      token
      stripeAccountId
    }
  }
`;

const GENERATE_PAYMENT_INTENT = gql`
  mutation generatePaymentIntent($transactionRef: String!) {
    generatePaymentIntent(transactionRef: $transactionRef) {
      id
      ref
      amount
      description
      customer {
        id
        firstName
        lastName
        phone
        email
      }
      merchant {
        stripeAccountId
        businessName
      }
      status
      applicationFeeAmount
      paymentIntentId
    }
  }
`;

const CONFIRM_PAYMENT = gql`
  mutation confirmPayment($transactionRef: String!, $status: String!) {
    confirmPayment(
      input: { transactionRef: $transactionRef, status: $status }
    ) {
      message
    }
  }
`;

const CREATE_CUSTOMER = gql`
  mutation createCustomer(
    $firstName: String!
    $lastName: String!
    $email: String
    $phone: String!
  ) {
    createCustomer(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
      }
    ) {
      id
      firstName
    }
  }
`;

const RESEND_SMS = gql`
mutation sendMessage($sms: String!) {
  sendMessage(input: $sms){
    messageSid
    messageStatus
  }
}
`;

const CREATE_STRIPE_CUSTOMER = gql`
  mutation createStripeCustomer($customerId: Int!) {
    createStripeCustomer(customerId: $customerId) {
      client_secret
    }
  }
`;

const SAVE_CUSTOMER_PAYMENT_METHOD = gql`
mutation saveCustomerPaymentMethod($payment_method: String!, $transactionRef: String!, $status: String!) {
    saveCustomerPaymentMethod(payment_method: $payment_method, transactionRef: $transactionRef, status: $status) {
      status
      client_secret
      payment_method
    }
  }
`;

const CREATE_PAYOUT= gql`
mutation createPayout{
  createPayout{
    status
  }
}
`;

const UPDATE_TRANSACTION = gql`
mutation updateTransaction($input: UpdateTransactionInput!) {
  updateTransaction(
    input: $input
  ) {
    message
  }
}
`

export {
  CREATE_MERCHANT,
  LOGIN_MUTATION,
  VERIFY_ACCOUNT,
  START_ONBOARDING,
  COMPLETE_ONBOARDING,
  GENERATE_PAYMENT_INTENT,
  CREATE_TRANSACTION,
  UPDATE_TRANSACTION,
  CONFIRM_PAYMENT,
  CREATE_CUSTOMER,
  RESEND_SMS,
  CREATE_STRIPE_CUSTOMER,
  SAVE_CUSTOMER_PAYMENT_METHOD,
  CREATE_PAYOUT
};
